
(function () {
  "use strict";

  // ─── WAIT FOR fancybox.js (loaded async by theme) ─────────────

  function waitForFancybox(cb) {
    if (window.Fancybox) return cb();
    var interval = setInterval(function () {
      if (window.Fancybox) {
        clearInterval(interval);
        cb();
      }
    }, 50);
  }

  // ─── GET LARGEST URL FROM SRCSET ──────────────────────────────

  function getBestSrc(img) {
    var srcset = img.getAttribute("srcset");
    if (!srcset) return null;
    var best = srcset.split(",").map(function (s) {
      var parts = s.trim().split(/\s+/);
      return { url: parts[0], w: parseFloat(parts[1]) || 0 };
    }).sort(function (a, b) { return b.w - a.w; });
    return best[0] ? best[0].url : null;
  }

  // ─── BUILD FANCYBOX ITEMS FROM <product-gallery> ──────────────

  function buildItems(gallery) {
    var slides = gallery.querySelectorAll(
      ".splide__track .splide__list > li"
    );
    // fallback for non-slider layout
    if (!slides.length) {
      slides = gallery.querySelectorAll("ul > li");
    }

    var items = [];

    slides.forEach(function (slide) {
      // ── Standard image (rendered by product-media snippet) ──
      var img = slide.querySelector("img.global-media-settings");
      if (img) {
        items.push({
          src: getBestSrc(img) || img.src,
          thumb: img.src,
          caption: img.alt || "",
          type: "image"
        });
        return;
      }

      // ── Deferred media — video / external_video ──────────────
      var deferred = slide.querySelector("deferred-media");
      if (deferred) {
        var poster = deferred.querySelector("img");
        var tmpl = deferred.querySelector("template");
        var videoSrc = null;

        if (tmpl) {
          var tmp = document.createElement("div");
          tmp.innerHTML = tmpl.innerHTML;
          var iframe = tmp.querySelector("iframe");
          var video  = tmp.querySelector("video");
          if (iframe) {
            videoSrc = iframe.src || iframe.getAttribute("src");
          } else if (video) {
            var src = video.querySelector("source");
            videoSrc = src
              ? (src.src || src.getAttribute("src"))
              : video.src;
          }
        }

        if (videoSrc) {
          items.push({
            src: videoSrc,
            type: "video",
            thumb: poster ? poster.src : "",
            caption: poster ? poster.alt || "" : ""
          });
        } else if (poster) {
          items.push({
            src: getBestSrc(poster) || poster.src,
            thumb: poster.src,
            caption: poster.alt || "",
            type: "image"
          });
        }
        return;
      }

      // ── 3D model — show poster as image ─────────────────────
      var modelImg = slide.querySelector("product-model img");
      if (modelImg) {
        items.push({
          src: getBestSrc(modelImg) || modelImg.src,
          thumb: modelImg.src,
          caption: modelImg.alt || "3D Model",
          type: "image"
        });
      }
    });

    return items;
  }

  // ─── OPEN FANCYBOX (same options structure as your other theme) ─

  function openFancybox(items, startIndex) {
    Fancybox.show(items, {
      startIndex: startIndex || 0,

      // Carousel / slider
      Carousel: {
        infinite: true,
        transition: "slide"
      },

      // Top toolbar — same right-side buttons as your other theme
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [],
          right: ["zoomIn", "zoomOut", "slideshow", "fullscreen", "thumbs", "close"]
        }
      },

      // Thumbnail strip at bottom (classic = horizontal strip)
      Thumbs: {
        type: "classic",
        showOnStart: true
      },

      // Slideshow
      Slideshow: {
        timeout: 4000
      },

      // Image zoom / pan
      Images: {
        zoom: true,
        Panzoom: {
          maxScale: 4
        }
      }
    });
  }

  // ─── BIND CLICKS ON MAIN SLIDER IMAGES ───────────────────────

  function bindGallery(gallery) {
    if (gallery.dataset.fbBound === "1") return;
    gallery.dataset.fbBound = "1";

    var items = buildItems(gallery);
    if (!items.length) {
      console.warn("[PDP FancyBox] No media found in", gallery.id || "<product-gallery>");
      return;
    }

    var slides = gallery.querySelectorAll(
      ".splide__track .splide__list > li"
    );
    if (!slides.length) slides = gallery.querySelectorAll("ul > li");

    slides.forEach(function (slide, index) {
      // Clickable main image
      var img = slide.querySelector("img.global-media-settings");
      if (img) {
        img.style.cursor = "zoom-in";
        img.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          openFancybox(items, index);
        });
      }

      // Video poster — only intercept before native video loads
      var posterBtn = slide.querySelector(".deferred-media__poster");
      if (posterBtn) {
        posterBtn.addEventListener("click", function (e) {
          var deferred = slide.querySelector("deferred-media");
          if (deferred && !deferred.getAttribute("loaded")) {
            e.preventDefault();
            e.stopPropagation();
            openFancybox(items, index);
          }
        });
      }
    });

    console.log(
      "[PDP FancyBox] Ready —",
      items.length,
      "items on",
      gallery.id || "<product-gallery>"
    );
  }

  // ─── INIT ─────────────────────────────────────────────────────

  function init() {
    var galleries = document.querySelectorAll("product-gallery");
    if (!galleries.length) {
      console.warn("[PDP FancyBox] <product-gallery> not found.");
      return;
    }
    galleries.forEach(bindGallery);
  }

  // ─── BOOT ─────────────────────────────────────────────────────

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      waitForFancybox(init);
    });
  } else {
    waitForFancybox(init);
  }

  // Re-init on Shopify theme editor section reload
  document.addEventListener("shopify:section:load", function () {
    waitForFancybox(function () {
      document.querySelectorAll("product-gallery[data-fb-bound]")
        .forEach(function (g) { delete g.dataset.fbBound; });
      init();
    });
  });

  // Public API — call after AJAX / quick-view loads
  window.initPDPFancyBox = init;

})();
